/**
 * @author Bilal Cinarli
 */

(function(app) {
    'use strict';

    app.animation = (function() {
        var initialized = false;

        var animations = {
            cloud1:       {
                selector:  '#cloud-1',
                animation: {
                    positions: {
                        desktop: [
                            {left: 0},
                            {left: 58}
                        ],
                        tablet: [
                            {left:0},
                            {left: 58}
                        ]
                    },
                    delay:     0.1,
                    opacity: 1
                },
                run:       'onLoad'
            },
            cloud1Out:    {
                selector:  '#cloud-1',
                animation: {
                    positions: {
                        desktop: [
                            {left: 58},
                            {left: 220}
                        ],
                        tablet: [
                            {left: 58},
                            {left: 220}
                        ]
                    },
                    opacity : 0
                },
                run:       'onScroll'
            },
            cloud2:       {
                selector:  '#cloud-2',
                animation: {
                    positions: {
                        desktop: [
                            {left: -50},
                            {left: 0}
                        ],
                        tablet: [
                            {left: 0},
                            {left: 50}
                        ]
                    },
                    delay:     0.1
                },
                run:       'onLoad'
            },
            cloud2Out:    {
                selector:  '#cloud-2',
                animation: {
                    positions: {
                        desktop: [
                            {left: 0},
                            {left: 250 }
                        ],
                        tablet: [
                            {left: 0},
                            {left: 250 }
                        ]
                    },
                    opacity: 0
                },
                run:       'onScroll'
            },
            cloud3:       {
                selector:  '#cloud-3',
                animation: {
                    positions: {
                        desktop: [
                            {left: -50},
                            {left: 155}
                        ] ,
                        tablet: [
                            {left: -50},
                            {left: 155}
                        ]
                    },
                    delay:     0.2,
                    opacity: 1
                },
                run:       'onLoad'
            },
            cloud3Out:    {
                selector:  '#cloud-3',
                animation: {
                    positions: {
                        desktop: [
                            {left: 155},
                            {left: 350}
                        ],
                        tablet: [
                            {left: 155},
                            {left: 350}
                        ]
                    },
                    opacity : 0
                },
                run:       'onScroll'
            },
            cloud4:       {
                selector:  '#cloud-4',
                animation: {
                    positions: {
                        desktop: [
                            {right: 50},
                            {right: 170}
                        ],
                        tablet: [
                            {right: 0},
                            {right: 100}
                        ]
                    },
                    delay:     0.5,
                    opacity: 1
                },
                run:       'onLoad'
            },
            cloud4Out:   {
                selector:  '#cloud-4',
                animation: {
                    positions: {
                        desktop: [
                            {right: 170 },
                            {right: 400}
                        ],
                        tablet: [
                            {right: 170 },
                            {right: 400}
                        ]
                    }
                },
                run:       'onScroll'
            },
            cloud5:       {
                selector:  '#cloud-5',
                animation: {
                    positions: {
                        desktop: [
                            {right: -80},
                            {right: 0}
                        ],
                        tablet: [
                            {right: -30},
                            {right: 20}
                        ]
                    },
                    delay:     0.2,
                    opacity: 1
                },
                run:       'onLoad'
            },
            cloud5Out:  {
                selector:  '#cloud-5',
                animation: {
                    positions: {
                        desktop: [
                            {right: 0 },
                            {right: 150}
                        ],
                        tablet: [
                            {right: 20 },
                            {right: 150}
                        ]
                    },
                    opacity: 0
                },
                run:       'onScroll'
            },
        };

        var init = function() {
            initialized = true;

            if(!app.isMediumScreen() && !app.isWideScreen()) {
                return false;
            }

            prepare();

            bind();
        };

        var bind = function() {
            $(window).load(function() {
                runOnLoad();
            });

            $(window).scroll(function() {
                runOnScroll();
            });
        };

        var prepare = function() {
            Object.keys(animations).forEach(function(item) {
                var animation = animations[item].animation,
                    positions = app.isMediumScreen() ? animation.positions.tablet : animation.positions.desktop;

                animations[item].tween = new TweenMax(animations[item].selector, 3, {
                    bezier:    {
                        type:       'soft',
                        values:     positions,
                        autoRotate: true,
                        ease:       Power1.easeOutOut
                    },
                    opacity:   animation.opacity,
                    transform: animation.transform,
                    delay:     animation.delay,
                    paused:    true
                });
            });
        };

        var runOnLoad = function() {
            Object.keys(animations).forEach(function(item) {
                if(animations[item].run === 'onLoad') {
                    animations[item].tween.play();
                }
            });
        };

        var runOnScroll = function() {
            var scroll = document.body.scrollTop;

            if(scroll < 700) {
                Object.keys(animations).forEach(function(item) {
                    if(animations[item].run === 'onScroll') {
                        animations[item].tween.progress(scroll / 700);
                    }
                });
            }
        };

        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized,
            animations:    animations
        };
    })();

    app.registerInit('animation');
})(engelsizyasam);